module.exports = __webpack_public_path__ + "huna_lite.df69dd63ca.webp";